import AOS from 'aos';

const DEFAULT_AOS_BREAKPOINT = 768;
const RESIZE_DEBOUNCE = 120;
const RESPONSIVE_AOS_SELECTOR = '[data-aos-desktop], [data-aos-mobile], [data-aos-delay-desktop], [data-aos-delay-mobile], [data-aos-duration-desktop], [data-aos-duration-mobile], [data-aos-easing-desktop], [data-aos-easing-mobile], [data-aos-offset-desktop], [data-aos-offset-mobile], [data-aos-anchor-placement-desktop], [data-aos-anchor-placement-mobile], [data-aos-once-desktop], [data-aos-once-mobile]';
const AOS_ATTRS = [
  'aos',
  'aos-delay',
  'aos-duration',
  'aos-easing',
  'aos-offset',
  'aos-anchor-placement',
  'aos-once',
];

let resizeTimer = null;

function setResponsiveAosAttr(element, attrName, variant) {
  const sourceAttrName = `data-${attrName}-${variant}`;
  const targetAttrName = `data-${attrName}`;

  if (element.hasAttribute(sourceAttrName)) {
    element.setAttribute(targetAttrName, element.getAttribute(sourceAttrName));
    return;
  }

  if (element.hasAttribute(targetAttrName)) {
    element.removeAttribute(targetAttrName);
  }
}

function applyResponsiveAos() {
  const elements = document.querySelectorAll(RESPONSIVE_AOS_SELECTOR);

  if (!elements.length) {
    return false;
  }

  elements.forEach((element) => {
    const breakpoint = Number(element.getAttribute('data-aos-breakpoint')) || DEFAULT_AOS_BREAKPOINT;
    const variant = window.innerWidth > breakpoint ? 'desktop' : 'mobile';

    AOS_ATTRS.forEach((attrName) => {
      setResponsiveAosAttr(element, attrName, variant);
    });
  });

  return true;
}

function refreshAos() {
  if (typeof AOS.refreshHard === 'function') {
    AOS.refreshHard();
  }
}

window.refreshAos = refreshAos;

function updateResponsiveAos(shouldRefresh) {
  const hasResponsiveAosElements = applyResponsiveAos();

  if (shouldRefresh && hasResponsiveAosElements) {
    refreshAos();
  }
}

function initResponsiveAosConfig() {
  updateResponsiveAos(false);

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      updateResponsiveAos(true);
    }, RESIZE_DEBOUNCE);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initResponsiveAosConfig);
} else {
  initResponsiveAosConfig();
}
